import { render, staticRenderFns } from "./CarFutures.vue?vue&type=template&id=74d521f5&"
import script from "./CarFutures.vue?vue&type=script&lang=js&"
export * from "./CarFutures.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports